export default __webpack_public_path__ + "maps-examples-default-callout-thumbnail-480-f9960c0eed6a134cdc559527ba507c62.png";